module.exports = __webpack_public_path__ + "static/media/shadow.1add9ee7.png";